"use strict";

import _regeneratorRuntime from "/app/node_modules/@babel/runtime/regenerator/index.js";
var __async = function __async(__this, __arguments, generator) {
  return new Promise(function (resolve, reject) {
    var fulfilled = function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = function rejected(value) {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = function step(x) {
      return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
export var copyToClipboard = function copyToClipboard(value, onError) {
  return __async(void 0, null, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!(navigator == null ? void 0 : navigator.clipboard)) {
            _context.next = 11;
            break;
          }
          _context.prev = 1;
          _context.next = 4;
          return navigator.clipboard.writeText(value);
        case 4:
          _context.next = 9;
          break;
        case 6:
          _context.prev = 6;
          _context.t0 = _context["catch"](1);
          fallback(value, onError);
        case 9:
          _context.next = 12;
          break;
        case 11:
          fallback(value, onError);
        case 12:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 6]]);
  }));
};
var fallback = function fallback(value, onError) {
  try {
    var copyElement = document.createElement("textarea");
    copyElement.value = value;
    document.body.appendChild(copyElement);
    copyElement.select();
    document.execCommand("copy");
    copyElement.remove();
  } catch (error) {
    if (onError) onError();
  }
};